import { render, staticRenderFns } from "./ReturnPickUp.vue?vue&type=template&id=65171481&scoped=true"
import script from "./ReturnPickUp.vue?vue&type=script&lang=js"
export * from "./ReturnPickUp.vue?vue&type=script&lang=js"
import style0 from "./ReturnPickUp.vue?vue&type=style&index=0&id=65171481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65171481",
  null
  
)

export default component.exports